import React from "react";
import loadable from "@loadable/component";

const FallbackPlaceholder = loadable(() =>
  import(/* webpackPrefetch: true */ "../common/FallbackPlaceholder")
);

const Hero = loadable(() => import(/* webpackPrefetch: true */ "./Hero"));
const MilaComparison = loadable(() =>
  import("../landing-refresh/MilaComparison")
);
const FilterTab = loadable(() => import("./FilterTab"));
const FilterGraph = loadable(() => import("./FilterGraph"));
const FilterSpecs = loadable(() => import("./FilterSpecs"));
const ProductStats = loadable(() => import("./ProductStats"));
const FilterHepaStats = loadable(() => import("./FilterHepaStats"));
const FilterRecommendation = loadable(() => import("./FilterRecommendation"));
const FilterSock = loadable(() => import("./FilterSock"));
const FilterReplacement = loadable(() => import("./FilterReplacement"));
const FilterServices = loadable(() => import("./FilterService"));
// const FilterFaqs = loadable(() => import("./FilterFaq"));
const PerformanceChart = loadable(() => import("./PerformanceChart"));

/**
 * @param {Object} props
 * @return {JSX.Element}
 * @constructor
 */

const comparisonHeader = {
  className: "mila-comparison--performance",
  title: "Little known fact... ",
  subTitle: "Most home air purifiers are secretly huuuge.",
  description: (
    <>
      <p>
        They may look normal-sized online, but unbox one, and suddenly you’ve
        adopted a small aircraft carrier. Mila flips the script—delivering over
        60% more power per pound in half the size.
      </p>
      <p>Big on clean air. Small on taking over your living room..</p>
    </>
  ),
};

const ConponentWrapper = () => {
  return (
    <>
      <Hero fallback={<FallbackPlaceholder />} />
      <MilaComparison {...comparisonHeader} />
      <FilterTab />
      <FilterGraph />
      <FilterSpecs />
      <FilterHepaStats />
      <PerformanceChart />
      <ProductStats />
      <FilterRecommendation />
      <FilterSock />
      <FilterReplacement />
      <FilterServices />
      {/* <FilterFaqs /> */}
    </>
  );
};

export default ConponentWrapper;
